module.exports = __webpack_public_path__ + "infocentrum4.jpg?55eeb2d431f344ea64936d6b7b7c6676";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum4.jpg
// module id = 256
// module chunks = 0